import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "review-module-container" }
const _hoisted_2 = { class: "global-video-card" }
const _hoisted_3 = { class: "card-left" }
const _hoisted_4 = { class: "badge-icon" }
const _hoisted_5 = { class: "card-right" }
const _hoisted_6 = { class: "select-bar-wrapper" }
const _hoisted_7 = { class: "form-container" }
const _hoisted_8 = { class: "panel" }
const _hoisted_9 = { class: "panel_left" }
const _hoisted_10 = { class: "single-uploader-card" }
const _hoisted_11 = {
  key: 0,
  class: "img-preview-box"
}
const _hoisted_12 = { class: "hover-mask" }
const _hoisted_13 = {
  key: 1,
  class: "upload-trigger"
}
const _hoisted_14 = { class: "action-bar" }
const _hoisted_15 = { class: "panel_right" }
const _hoisted_16 = { class: "mockup-phone" }
const _hoisted_17 = { class: "phone-screen" }
const _hoisted_18 = { class: "mock-nav" }
const _hoisted_19 = { class: "screen-media" }
const _hoisted_20 = {
  key: 1,
  class: "media-placeholder"
}
const _hoisted_21 = { class: "screen-body" }
const _hoisted_22 = { class: "screen-title" }
const _hoisted_23 = { class: "screen-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoCamera = _resolveComponent("VideoCamera")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_segmented = _resolveComponent("el-segmented")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_PictureFilled = _resolveComponent("PictureFilled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_VideoCamera)
            ]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-group" }, [
          _createElementVNode("span", { class: "card-title" }, "全局复盘视频"),
          _createElementVNode("span", { class: "card-sub" }, "配置游戏通关后总览视频的嵌入式播放地址")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.globalReviewLink,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.globalReviewLink) = $event)),
          placeholder: "请输入视频链接 (例如: https://...)",
          clearable: "",
          class: "global-input"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_button, {
          type: "primary",
          class: "global-save-btn",
          onClick: _ctx.saveReviewLink
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" 保存全局视频 ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_segmented, {
        modelValue: _ctx.levelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.levelValue) = $event)),
        options: _ctx.levelsOptions,
        block: "",
        onChange: _ctx.changeOption,
        size: "large",
        class: "selectBar"
      }, null, 8, ["modelValue", "options", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            "label-width": "auto",
            "label-position": "top",
            ref: "ruleForm",
            "status-icon": "",
            class: "clean-form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "关卡复盘标题" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.reviewTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.reviewTitle) = $event)),
                    placeholder: "例如：本关核心推理逻辑与背景复盘",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "复盘正文内容" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.reviewContent,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.reviewContent) = $event)),
                    type: "textarea",
                    placeholder: "详细复盘本关涉及的剧情暗线、解题思路与通关线索...",
                    rows: 8,
                    maxlength: "500",
                    "show-word-limit": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "复盘配图" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_el_upload, {
                      class: "uploader-box",
                      action: _ctx.UpdateApi,
                      "show-file-list": false,
                      "on-success": _ctx.handleAvatarSuccess,
                      "before-upload": _ctx.beforeAvatarUpload,
                      disabled: _ctx.allowUpload
                    }, {
                      default: _withCtx(() => [
                        (_ctx.form.reviewImg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_el_image, {
                                src: _ctx.form.reviewImg,
                                class: "img-content",
                                fit: "contain"
                              }, null, 8, ["src"]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("span", {
                                  class: "del-btn",
                                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)), ["stop"])),
                                  title: "删除图片"
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Delete)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_el_icon, { class: "icon" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Plus)
                                ]),
                                _: 1
                              }),
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text" }, "上传复盘附图", -1)),
                              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sub-text" }, "支持 4:3 | 1:1 | 3:4 / 小于 5MB", -1))
                            ]))
                      ]),
                      _: 1
                    }, 8, ["action", "on-success", "before-upload", "disabled"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_button, {
              type: "primary",
              class: "save-btn",
              size: "large",
              onClick: _ctx.saveSettings
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" 保存当前关卡复盘 ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "preview-header" }, [
            _createElementVNode("span", { class: "badge-dot" }),
            _createElementVNode("span", null, "移动端复盘呈现")
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "phone-top-bar" }, [
              _createElementVNode("div", { class: "notch" })
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "nav-title" }, "关卡复盘", -1)),
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "nav-placeholder" }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_19, [
                (_ctx.form.reviewImg)
                  ? (_openBlock(), _createBlock(_component_el_image, {
                      key: 0,
                      src: _ctx.form.reviewImg,
                      alt: "复盘配图",
                      class: "preview-img",
                      fit: "contain"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_el_icon, { class: "ph-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PictureFilled)
                        ]),
                        _: 1
                      }),
                      _cache[12] || (_cache[12] = _createElementVNode("span", null, "暂无复盘配图", -1))
                    ]))
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.form.reviewTitle || "复盘标题占位"), 1),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.form.reviewContent ||
                    "关卡解析、真相还原或复盘要点内容将在此处展示，支持自动断行与上下平滑滑动..."), 1)
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "screen-footer" }, [
                _createElementVNode("button", { class: "mock-next-btn" }, "已完成复盘，继续")
              ], -1))
            ])
          ])
        ])
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "zhanwei4" }, null, -1))
  ]))
}